// extracted by mini-css-extract-plugin
export default {"experiments":"Experiments_experiments__LIEJr","title":"Experiments_title__McOBl","mobileTitle":"Experiments_mobileTitle__a0+MG","cards":"Experiments_cards__M1DJa"};